export default "__VITE_ASSET__B0F4JUng__"